import type { PacketId } from './types';

export interface Port {
  capacity: number;
  queue: PacketId[];
}

export function createPort(capacity: number): Port {
  return { capacity, queue: [] };
}

export function tryPushToPort(port: Port, packetId: PacketId): boolean {
  if (port.queue.length >= port.capacity) {
    return false;
  }
  port.queue.push(packetId);
  return true;
}

export function tryTakeFromPort(port: Port): PacketId | undefined {
  return port.queue.shift();
}

export function peekPort(port: Port): PacketId | undefined {
  return port.queue[0];
}

export function portHasRoom(port: Port): boolean {
  return port.queue.length < port.capacity;
}

function onlyPort(ports: Port[], label: string): Port {
  if (ports.length !== 1) {
    throw new Error(`expected exactly 1 ${label} port, got ${ports.length}`);
  }
  return ports[0];
}

export function singleInput(inputs: Port[]): Port {
  return onlyPort(inputs, 'input');
}

export function singleOutput(outputs: Port[]): Port {
  return onlyPort(outputs, 'output');
}
